import toast from "react-hot-toast";
import { validateEmail } from "./validate-email";

export const handleMailingList = async (firstName, email) => {
  if (!validateEmail(email)) {
    toast.error("The email is invalid.");
    return;
  }

  const res = await fetch("/api/subscribe", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ firstName, email, groups: ["b6xJYz"] }),
  });

  if (res.ok) toast.success("You have been subscribed!");
  else toast.error("There was an issue signing up for the waitlist");
};
